module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k0Iyn"))).then(() => parcelRequire('d0iPb'));